<template>
  <div class="warp">
    <el-card class="box-card" style="width:100%">
      <div class="box-card_ewap">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item :label="dataobjs.yuanmima" prop="optpassword">
            <el-input v-model="ruleForm.optpassword" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="dataobjs.xinmima" prop="newoptpassword">
            <el-input v-model="ruleForm.newoptpassword" autocomplete="off" show-password></el-input>
          </el-form-item>
          <!-- <el-form-item label="确认密码" prop="newoptpasswordTS">
            <el-input v-model="ruleForm.newoptpasswordTS" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item>
           <div class="btenEtiel">
              <el-button type="primary" @click="submitForm('ruleForm')" class="confName">{{dataobjs.qudingxiugai}}</el-button>
            <el-button @click="resetForm('ruleForm')">{{dataobjs.chongzhi}}</el-button>
           </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import {Updatepassword,lang_fend} from '@/network/index'
import md5 from "js-md5";
export default {
  data() {
    return {
      ruleForm: {
        optpassword: "",
        newoptpassword:'',
        // newoptpasswordTS:''
      },
      dataobjs:{},
      rules: {
        optpassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
          //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        newoptpassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
          //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
          lang_file: sessionStorage.getItem("lang_file"),
        // newoptpasswordTS: [
        //   { required: true, message: "确认密码", trigger: "blur" }
        //   //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        // ]
      }
    };
  },
  mounted(){
    this.lang_fend()
  },
  methods: {
      async lang_fend(){
      let page = 'userpassword_page'
      let objs = {
        page,
        lang_file:this.lang_file,
      }
      const {data,code} = await lang_fend(objs)
      this.dataobjs = data
      },
    //   确认
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
             let optpassword1 = md5(this.ruleForm.optpassword);//旧密码
             let newoptpassword1 = md5(this.ruleForm.newoptpassword)//新密码
             let objs = {
               optpassword:optpassword1.toUpperCase(),//原密码
               newoptpassword:newoptpassword1.toUpperCase()//新密码
             }
            //  console.log(objs)
          const {code,msg} = await Updatepassword(objs)
          if(code){
            this.$message.success(msg)
            this.ruleForm = {}
          }else{
             this.$message.error(msg)
          }
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //    取消
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style scoped>
.warp {
  width: 40%;
  margin: 0 auto;
}
.box-card_ewap {
  width: 80%;
}
.confName {
  text-align: center;
}
</style>